import React, { useState } from "react";
import { RegularButton } from "../../../common/ReusableComponent/CustomButton";
import {
  ReusableInput,
  ReusableDateInput,
  SelectInput,
} from "../../../common/ReusableComponent/ReusableInput";
import ReusableModal from "../ManageSettings/ReusableModal";
import { useToastHandler } from "../../../common/ToastHandler";

const ScheduleModal = ({ show, onClose, selectedEmployee }) => {
  const { handleToast } = useToastHandler();

  const initialScheduleData = {
    employee_name: selectedEmployee?.full_name || "",
    next_payroll_date: new Date().toISOString().split("T")[0],
    unit_select: "",
    total_working_hours: "",
    amount_per_hour: "",
    basic_working_hours_amount: "",
    pay_method: "",
    deduct_hours: "",
    deduction_rate_per_hour: "",
    extra_hours_worked: "",
    extra_working_amount_per_hour: "",
    total_payable_amount: "",
    notes: "",
  };

  const [scheduleData, setScheduleData] = useState(initialScheduleData);

  const handleScheduleChange = (e) => {
    const { name, value } = e.target;
    
    // Validate length for numeric fields
    const numericFields = [
      'total_working_hours', 'amount_per_hour', 'basic_working_hours_amount',
      'deduct_hours', 'deduction_rate_per_hour', 'extra_hours_worked',
      'extra_working_amount_per_hour', 'total_payable_amount'
    ];
    
    if (numericFields.includes(name) && value.length > 10) {
      return; // Don't update if length exceeds 10
    }
    
    setScheduleData((prevData) => ({ ...prevData, [name]: value }));
  };

  const clearScheduleForm = () => {
    setScheduleData({
      ...initialScheduleData,
      employee_name: selectedEmployee?.full_name || "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleToast({
      type: "SUCCESS",
      message: "Schedule created successfully!",
    });
    onClose();
  };

  const handleClose = () => {
    setScheduleData(initialScheduleData);
    onClose();
  };

  return (
    <ReusableModal
      show={show}
      handleClose={handleClose}
      title={`Schedule For ${selectedEmployee?.full_name || ""}`}
      width="800px"
    >
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="d-flex align-items-center mb-4 mx-3">
            <ReusableDateInput
              name="next_payroll_date"
              label="Next Payroll Date"
              value={scheduleData.next_payroll_date}
              onChange={handleScheduleChange}
              required
              containerStyle={{ width: "350px" }}
            />
            <SelectInput
              name="salary_unit"
              value={scheduleData.salary_unit}
              onChange={handleScheduleChange}
              required
              placeholder="Per Unit"
              label="Salary Unit"
              options={[
                { id: "hourly", name: "Hourly" },
                { id: "weekly", name: "Weekly" },
                { id: "bi weekly", name: "Bi Weekly" },
                { id: "monthly", name: "Monthly" },
              ]}
              style={{ width: "350px" }}
            />
          </div>

          <div className="d-flex align-items-center mb-4 mx-3">
            <ReusableInput
              type="number"
              name="total_working_hours"
              label="Total Working Hours This Month"
              value={scheduleData.total_working_hours}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
            <ReusableInput
              type="number"
              name="amount_per_hour"
              label="Amount Per Hour"
              value={scheduleData.amount_per_hour}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
          </div>

          <div className="d-flex align-items-center mb-4 mx-3">
            <ReusableInput
              type="number"
              name="basic_working_hours_amount"
              label="Basic Working Hours Total Amount"
              value={scheduleData.basic_working_hours_amount}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
            <ReusableInput
              type="select"
              name="pay_method"
              label="Pay Method"
              value={scheduleData.pay_method}
              onChange={handleScheduleChange}
              options={[
                { value: "cash", label: "Cash" },
                { value: "bank_transfer", label: "Bank Transfer" },
                { value: "cheque", label: "Cheque" },
              ]}
            />
          </div>

          <div className="d-flex align-items-center mb-4 mx-3">
            <ReusableInput
              type="number"
              name="deduct_hours"
              label="Deduct Number of Hours"
              value={scheduleData.deduct_hours}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
            <ReusableInput
              type="number"
              name="deduction_rate_per_hour"
              label="Deduction Rate Per Hour"
              value={scheduleData.deduction_rate_per_hour}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
          </div>

          <div className="d-flex align-items-center mb-4 mx-3">
            <ReusableInput
              type="number"
              name="extra_hours_worked"
              label="Extra Hours Worked"
              value={scheduleData.extra_hours_worked}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
            <ReusableInput
              type="number"
              name="extra_working_amount_per_hour"
              label="Extra Working Amount Per Hour"
              value={scheduleData.extra_working_amount_per_hour}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
            />
          </div>

          <div className="d-flex align-items-center mb-4 mx-3">
            <ReusableInput
              type="number"
              name="total_payable_amount"
              label="Total Payable Amount"
              value={scheduleData.total_payable_amount}
              onChange={handleScheduleChange}
              placeholder=""
              maxLength={10}
              readOnly
            />
          </div>
        </div>

        {/* </div> */}

        <div className="modal-footer" style={{ border: "none", gap: "10px" }}>
          <RegularButton
            text="Stop Payroll This Time"
            onClick={handleClose}
            backgroundColor="#dc3545"
            color="#ffffff"
            style={{ width: "200px" }}
          />
          <RegularButton
            text="Set This For Current Payroll Only"
            onClick={handleSubmit}
            backgroundColor="#17a2b8"
            style={{ width: "300px" }}
            color="#ffffff"
          />
          <RegularButton
            type="submit"
            text="Set This As Default"
            backgroundColor="#282E26"
            color="#ffffff"
            style={{ width: "200px" }}
          />
        </div>
      </form>
    </ReusableModal>
  );
};

export default ScheduleModal;
